<template>
  <div id="app" v-on:wheel.prevent>
    <Navbar v-if="showHeader" :landscape="landscape"></Navbar>
    <Loading v-if="loading"></Loading>
    <router-view :landscape="landscape" v-else></router-view>
    <div class="footer" v-if="showFooter">
      <p>&copy; Qingdao Blackbeans Creativity Software Co., Ltd.</p>
    </div>
    <div ref="hairline" class="test-hairline"></div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Dashboard from './components/Dashboard.vue'
import Loading from './components/Loading.vue'
export default {
  name: 'app',
  data () {
    return {
      landscape: true,
      hairline: true,
      loading: true
    }
  },
  computed: {
    showFooter: function () {
      return !(this.$route.name === 'Contact')
    },
    showHeader: function () {
      return !(this.$route.name === 'Contact')
    }
  },
  created () {
    const self = this
    this.landscape = window.innerWidth > window.innerHeight
    this.setFontsize()
    window.addEventListener('resize', function () {
      self.setFontsize()
    })
    window.addEventListener('touchmove', function (e) {
      let lastY = 0
      self.preventPullToRefresh(e, lastY)
    })
    window.addEventListener('orientationchange', function () {
      self.setFontsize()
      self.landscape = !self.landscape
    }, false)
    setTimeout(() => {
      self.loading = false
    }, 2000)
  },
  mounted () {
    this.checkRetina()
  },
  components: {
    Navbar,
    Dashboard,
    Loading
  },
  methods: {
    preventPullToRefresh: function (e, lastY) {
      const { pageY } = e.changedTouches[0]
      const scrollY = window.pageYOffset || window.scrollTop || 0
      if (pageY > lastY && scrollY === 0) {
        e.preventDefault()
      }
      lastY = pageY
    },
    setFontsize: function () {
      if (this.landscape) {
        document.documentElement.style.fontSize = window.innerWidth / 17 + 'px'
      } else {
        document.documentElement.style.fontSize = window.innerWidth / 8 + 'px'
      }
    },
    checkRetina: function () {
      if (window.devicePixelRatio && window.devicePixelRatio >= 2) {
        if (this.$refs.hairline.offsetHeight === 1) {
          this.hairline = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import './Global.scss';
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
}

#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  @include flexBox(column, nowrap, space-between, center);
}

.hairline {
  div, li {
    border-top-width: 0.5px !important;
    border-bottom-width: 0.5px !important;
    border-left-width: 0.5px !important;
    border-right-width: 0.5px !important;
  }
}
.test-hairline {
  position: fixed;
  bottom: -1px;
  border: .5px solid transparent;
}
.footer {
  background-color: #fff;
  p {
    font-size: .12rem;
    color: #888;
    padding: .2rem;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue